<div class="d-flex justify-content-between text-nowrap">
    <label class="d-inline-block mr-2">{{label}}</label>
    <div class="custom-control custom-switch" (click)="changed(!h.value)" >
        <input type="checkbox" class="custom-control-input" [checked]="h.value && h.value.toString() == 'true'">
        <label class="custom-control-label" for="customSwitch1"></label>
      </div>
</div>